// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__7ra99","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__3yvd8"};